'use client';

import clsx from 'clsx';

import { nanoid } from 'nanoid';

import { Chip, Icon, ImageClient, Typography } from '@/components/core';
import { ExperienceStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './ExperienceCard.module.scss';

type ExperienceCardProps = {
    blok: ExperienceStoryblok;
    types?: string[];
    className?: string;
};

export const ExperienceCard = ({ blok, className, types }: ExperienceCardProps) => {
    const { type, title, coverImage, description, amountOfPeople, dates } = blok;

    return (
        <div className={clsx(styles.root, className)}>
            {coverImage?.filename && (
                <div className={clsx(styles.imageWrapper)}>
                    <ImageClient
                        src={coverImage.filename}
                        alt={coverImage.alt}
                        focalPoints={coverImage.focalPoints}
                        width={350}
                        height={300}
                        className={styles.coverImage}
                    />
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.topContent}>
                    <div className={clsx(styles.typeWrapper, styles.flex)}>
                        {type.map(item => (
                            <Chip
                                key={nanoid()}
                                text={item as string}
                                colorId={types.indexOf(item as string) + 1}
                            />
                        ))}
                    </div>
                    <Typography
                        as="h4"
                        className={styles.title}
                    >
                        {title}
                    </Typography>
                    <Typography
                        looksLike="pSmall"
                        className={styles.description}
                    >
                        {description}
                    </Typography>
                </div>

                <div className={clsx(styles.bottomCard, styles.flex)}>
                    <div className={styles.flex}>
                        <Icon
                            style={{
                                fontSize: '24px',
                            }}
                            name="calendar"
                        />
                        {dates}
                    </div>
                    <div className={styles.flex}>
                        <Icon
                            style={{
                                fontSize: '24px',
                            }}
                            name="people"
                        />
                        {amountOfPeople}
                    </div>
                </div>
            </div>
        </div>
    );
};
